var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "application-config" },
    [
      _c("div", { staticClass: "app-section" }, [
        _c(
          "div",
          { staticClass: "section-header" },
          [
            _c("span", { staticClass: "section-title" }, [
              _vm._v("微信小程序"),
            ]),
            _c(
              "el-button",
              {
                staticClass: "add-btn",
                attrs: { type: "primary", size: "small" },
                on: {
                  click: function ($event) {
                    return _vm.handleAdd("wechat")
                  },
                },
              },
              [_vm._v("新增\n      ")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "section-content" },
          [
            _c(
              "el-form",
              {
                ref: "wexin",
                attrs: {
                  rules: _vm.rules,
                  "label-width": "20px",
                  model: _vm.form,
                },
              },
              [
                _c(
                  "el-table",
                  { attrs: { data: _vm.form.wechat, border: "" } },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "name", label: "名称" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "",
                                    prop: "wechat." + scope.$index + ".name",
                                    rules: _vm.rules.name,
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "微信小程序链接" },
                                    model: {
                                      value: scope.row.name,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "name", $$v)
                                      },
                                      expression: "scope.row.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm.isEdit
                      ? _c("el-table-column", {
                          attrs: { prop: "shortUrl", label: "链接" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.shortUrl
                                      ? _c("div", [
                                          _c(
                                            "a",
                                            {
                                              staticStyle: { color: "#0a85f8" },
                                              attrs: {
                                                href: scope.row.shortUrl,
                                                target: "_blank",
                                              },
                                            },
                                            [_vm._v(_vm._s(scope.row.shortUrl))]
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-download copy-icon",
                                            staticStyle: {
                                              "margin-left": "5px",
                                              cursor: "pointer",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.downLoadUrl(
                                                  scope.row
                                                )
                                              },
                                            },
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-document-copy copy-icon",
                                            staticStyle: {
                                              "margin-left": "5px",
                                              cursor: "pointer",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copyUrl(
                                                  scope.row.shortUrl
                                                )
                                              },
                                            },
                                          }),
                                        ])
                                      : _c("div", [_vm._v("-")]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2963837208
                          ),
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "120" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDelete(
                                        "wechat",
                                        scope.$index
                                      )
                                    },
                                  },
                                },
                                [_vm._v("删除\n              ")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "app-section" }, [
        _c(
          "div",
          { staticClass: "section-header" },
          [
            _c("span", { staticClass: "section-title" }, [
              _vm._v("支付宝小程序"),
            ]),
            _c(
              "el-button",
              {
                staticClass: "add-btn",
                attrs: { type: "primary", size: "small" },
                on: {
                  click: function ($event) {
                    return _vm.handleAdd("alipay")
                  },
                },
              },
              [_vm._v("新增\n      ")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "section-content" },
          [
            _c(
              "el-form",
              {
                ref: "alipay",
                attrs: {
                  rules: _vm.rules,
                  "label-width": "20px",
                  model: _vm.form,
                },
              },
              [
                _c(
                  "el-table",
                  { attrs: { data: _vm.form.alipay, border: "" } },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "name", label: "名称" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "alipay." + scope.$index + ".name",
                                    rules: _vm.rules.name,
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "支付宝小程序名称" },
                                    model: {
                                      value: scope.row.name,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "name", $$v)
                                      },
                                      expression: "scope.row.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm.isEdit
                      ? _c("el-table-column", {
                          attrs: { prop: "shortUrl", label: "链接" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.shortUrl
                                      ? _c("div", [
                                          _c(
                                            "a",
                                            {
                                              staticStyle: { color: "#0a85f8" },
                                              attrs: {
                                                href: scope.row.shortUrl,
                                                target: "_blank",
                                              },
                                            },
                                            [_vm._v(_vm._s(scope.row.shortUrl))]
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-download copy-icon",
                                            staticStyle: {
                                              "margin-left": "5px",
                                              cursor: "pointer",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.downLoadUrl(
                                                  scope.row
                                                )
                                              },
                                            },
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-document-copy copy-icon",
                                            staticStyle: {
                                              "margin-left": "5px",
                                              cursor: "pointer",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copyUrl(
                                                  scope.row.shortUrl
                                                )
                                              },
                                            },
                                          }),
                                        ])
                                      : _c("div", [_vm._v("-")]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2963837208
                          ),
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "120" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDelete(
                                        "alipay",
                                        scope.$index
                                      )
                                    },
                                  },
                                },
                                [_vm._v("删除\n              ")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      false
        ? _c("div", { staticClass: "app-section" }, [
            _c(
              "div",
              { staticClass: "section-header" },
              [
                _c("span", { staticClass: "section-title" }, [
                  _vm._v("抖音小程序"),
                ]),
                _c(
                  "el-button",
                  {
                    staticClass: "add-btn",
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleAdd("douyin")
                      },
                    },
                  },
                  [_vm._v("新增\n      ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section-content" },
              [
                _c(
                  "el-form",
                  {
                    ref: "douyin",
                    attrs: {
                      rules: _vm.rules,
                      "label-width": "20px",
                      model: _vm.form,
                    },
                  },
                  [
                    _c(
                      "el-table",
                      { attrs: { data: _vm.form.douyin, border: "" } },
                      [
                        _c("el-table-column", {
                          attrs: { prop: "name", label: "名称" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "douyin." + scope.$index + ".name",
                                          rules: _vm.rules.name,
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "抖音小程序名称",
                                          },
                                          model: {
                                            value: scope.row.name,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "name", $$v)
                                            },
                                            expression: "scope.row.name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3946117923
                          ),
                        }),
                        _vm.isEdit
                          ? _c("el-table-column", {
                              attrs: { prop: "shortUrl", label: "链接" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.shortUrl
                                          ? _c("div", [
                                              _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    color: "#0a85f8",
                                                  },
                                                  attrs: {
                                                    href: scope.row.shortUrl,
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(scope.row.shortUrl)
                                                  ),
                                                ]
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-download copy-icon",
                                                staticStyle: {
                                                  "margin-left": "5px",
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.downLoadUrl(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              }),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-document-copy copy-icon",
                                                staticStyle: {
                                                  "margin-left": "5px",
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyUrl(
                                                      scope.row.shortUrl
                                                    )
                                                  },
                                                },
                                              }),
                                            ])
                                          : _c("div", [_vm._v("-")]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2963837208
                              ),
                            })
                          : _vm._e(),
                        _c("el-table-column", {
                          attrs: { label: "操作", width: "120" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDelete(
                                              "douyin",
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("删除\n              ")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1662394276
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      false
        ? _c("div", { staticClass: "app-section" }, [
            _c(
              "div",
              { staticClass: "section-header" },
              [
                _c("span", { staticClass: "section-title" }, [
                  _vm._v("乘客端APP"),
                ]),
                _c(
                  "el-button",
                  {
                    staticClass: "add-btn",
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleAdd("app")
                      },
                    },
                  },
                  [_vm._v("新增\n      ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section-content" },
              [
                _c(
                  "el-form",
                  {
                    ref: "app",
                    attrs: {
                      rules: _vm.rules,
                      "label-width": "20px",
                      model: _vm.form,
                    },
                  },
                  [
                    _c(
                      "el-table",
                      { attrs: { data: _vm.form.app, border: "" } },
                      [
                        _c("el-table-column", {
                          attrs: { prop: "name", label: "名称" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "app." + scope.$index + ".name",
                                          rules: _vm.rules.name,
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "APP名称" },
                                          model: {
                                            value: scope.row.name,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "name", $$v)
                                            },
                                            expression: "scope.row.name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            817529741
                          ),
                        }),
                        _vm.isEdit
                          ? _c("el-table-column", {
                              attrs: { prop: "shortUrl", label: "链接" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.shortUrl
                                          ? _c("div", [
                                              _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    color: "#0a85f8",
                                                  },
                                                  attrs: {
                                                    href: scope.row.shortUrl,
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(scope.row.shortUrl)
                                                  ),
                                                ]
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-download copy-icon",
                                                staticStyle: {
                                                  "margin-left": "5px",
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.downLoadUrl(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              }),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-document-copy copy-icon",
                                                staticStyle: {
                                                  "margin-left": "5px",
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyUrl(
                                                      scope.row.shortUrl
                                                    )
                                                  },
                                                },
                                              }),
                                            ])
                                          : _c("div", [_vm._v("-")]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2963837208
                              ),
                            })
                          : _vm._e(),
                        _c("el-table-column", {
                          attrs: { label: "操作", width: "120" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDelete(
                                              "app",
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("删除\n              ")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3718387237
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c("qr-load", {
        attrs: { qrCodeUrl: _vm.qrCodeUrl },
        model: {
          value: _vm.qrVisible,
          callback: function ($$v) {
            _vm.qrVisible = $$v
          },
          expression: "qrVisible",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }